import { useTranslation } from 'react-i18next';
import { MainLayout } from '../../Layout/MainLayout';
import { Button, Grid, TableContentIsland } from '@razz-team/ui-web';
import { PayoutsTable } from './PayoutsTable';
import { useCreatePayoutMutation } from '../../../api/payouts';
import { useCallback, useEffect } from 'react';
import { Route } from '../../../routes/account.payouts';
import { useIdempotencyKey } from '../../../hooks/useIdempotencyKey';
import { formatDate } from '@razz-team/utils';

export function PayoutsPage() {
  const { t } = useTranslation();
  const navigate = Route.useNavigate();

  const idempotencyKey = useIdempotencyKey();
  const createPayoutMutation = useCreatePayoutMutation({ idempotencyKey });

  const handleClickNewPayout = useCallback(() => {
    const date = formatDate(new Date(), 'date');
    createPayoutMutation.mutate({ name: t('Payout {{date}}', { date }) });
  }, [createPayoutMutation, t]);

  useEffect(() => {
    if (createPayoutMutation.data) {
      navigate({
        to: '/account/payouts/$payoutId/create',
        params: { payoutId: createPayoutMutation.data.id },
        search: { createdAt: createPayoutMutation.data.createdAt },
      });
    }
  }, [createPayoutMutation.data, navigate]);

  return (
    <MainLayout
      title={t('Payouts')}
      actions={<Button onClick={handleClickNewPayout}>{t('New payout')}</Button>}
    >
      <Grid size={12}>
        <TableContentIsland>
          <PayoutsTable />
        </TableContentIsland>
      </Grid>
    </MainLayout>
  );
}
